import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { useAdvertFavoriteState } from '#advertFavorite/hooks';
import { favoriteHide, favoriteOpen } from '#advertFavorite/reducers';

const useAdvertFavoriteVisibleControl = () => {
  const { isOpen } = useAdvertFavoriteState();
  const dispatch = useDispatch();

  const triggerOpen = useCallback(() => {
    dispatch(favoriteOpen());
  }, [dispatch]);

  const triggerHide = useCallback((): Promise<void> => new Promise((resolve) => {
    dispatch(favoriteHide());

    setTimeout(() => {
      resolve();
    }, 400);
  }), [dispatch]);

  return {
    isOpen,
    open: triggerOpen,
    hide: triggerHide,
  };
};

export { useAdvertFavoriteVisibleControl };
